import React from 'react';
import './Developer.css';
import { Link as Anchor } from 'react-router-dom';

export default function Developer() {

    const year = new Date().getFullYear();

    return (
        <p className='Developer'>
            © Copyright {year}
        </p>
    );
}
